/**
 * Module dependencies.
 */

import { CardPricing } from 'src/components/core/cards/card-pricing';
import { CardPricingPack } from 'src/components/core/cards/card-pricing-pack';
import { FadeInUp } from 'src/components/core/animations/fade-in-up';

/*
 * `Props` type.
 */

type Props = {
  services: Service[];
  staggerMobile?: boolean;
  triggerInView?: boolean;
};

/**
 * `Pack` type.
 */

type Pack = {
  description?: string;
  descriptionTwelveMonths?: string;
  name?: string;
  price?: number;
  priceTwelveMonths?: number;
};

/**
 * Export `Service` type.
 */

export type Service = {
  description?: string;
  detailsUrl?: string;
  hideDescription?: boolean;
  hideDetailsUrl?: boolean;
  hidePackHeader?: boolean;
  hidePackUrls?: boolean;
  hideServiceHeader?: boolean;
  hideServiceInfo?: boolean;
  label?: string;
  name?: string;
  packs?: Pack[];
};

/**
 * Export `PricingPack` component.
 */

export const PricingPack = ({ services, staggerMobile, triggerInView }: Props) =>
  services?.map(({ hideDescription, hideServiceInfo, name, packs, ...rest }, index) => (
    <FadeInUp
      key={index}
      staggerMobile={staggerMobile}
      style={{ marginBottom: index !== services.length - 1 ? 'var(--space-xxs)' : 0 }}
      triggerInView={triggerInView}
    >
      <CardPricingPack
        {...rest}
        pricringCards={packs?.map(({ name, ...packProps }, index) => (
          <CardPricing
            {...packProps}
            hideDescription={hideDescription}
            hideServiceInfo={hideServiceInfo}
            key={index}
            title={name}
          />
        ))}
        title={name}
      />
    </FadeInUp>
  ));
